import React, { useState, useEffect } from "react";
import styleConstants from "../../constants/styleConstants";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  IconButton,
  Typography,
} from "@material-ui/core";
import clsx from "clsx";
import EmptyOrShow from "../../components/EmptyOrShow";
import TableHeadComp from "../../pages/deals/view/TableHeadComp";
import { makeStyles } from "@material-ui/core/styles";
import { getNotifications, pushNotify, delNotice } from "./api";
import CustomButton from "../../components/UI/Button";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import SendIcon from "@material-ui/icons/Send";
import CheckIcon from "@material-ui/icons/Check";
import NotifyModal from "../../components/modal/modals/NotifyModal";
import { useDispatch } from "react-redux";
import { setShowModal } from "../../services/redux/actions/app-actions";
import { MODALS } from "../../constants";
import { useCustomSnackbar } from "../../utils/hooks/useCustomSnackbar";
import { unicodeEscapesToEmoji } from "utils/emojis";
import ExpandableText from "../../components/UI/ExpandableText";

const useStyles = makeStyles({
  wrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    padding: "60px 0 0 20px",
  },
  repair: {
    padding: "0 20px 20px",
  },
  table_container: {
    marginTop: 20,
    border: "1px solid #D2D3D9",
    borderRadius: 4,
  },
  table_body: {
    "& tr": {
      transition: "0.4s",
      "&:hover": {
        background: "#d3d3d36e",
      },
    },
  },
  checkbox_cell: {
    "& label": {
      margin: 0,
    },
  },
  actionButton: {
    padding: 6,
  },
  addButton: {
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    backgroundColor: styleConstants.primaryColor,
    color: "#fff",
  },
  editButton: {
    color: "#6191EF",
  },
  deleteButton: {
    color: "#FF6262",
  },
  sendButton: {
    color: "#4CAF50",
  },
});

function NotifyUsers() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { addDefaultSnack } = useCustomSnackbar();
  const [qNotifications, setQNotification] = useState([]); // q - queue
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedNotification, setSelectedNotification] = useState(null);

  const fetchNotifications = () => {
    setLoading(true);
    getNotifications()
      .then((res) => {
        setQNotification(res);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  const handleOpenModal = (notification = null) => {
    setSelectedNotification(notification);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedNotification(null);
  };

  const handleSuccess = (res) => {
    if (res) {
      setQNotification(res);
    } else {
      fetchNotifications();
    }
    addDefaultSnack("Уведомление успешно сохранено");
  };

  const handleDelete = (notice_id) => {
    dispatch(
      setShowModal(true, MODALS.confirmDelete, {
        title: "Удаление уведомления",
        titleModal: "Вы действительно хотите удалить уведомление?",
        handleDelete: () => {
          delNotice(notice_id)
            .then((res) => {
              fetchNotifications();
              addDefaultSnack("Уведомление успешно удалено");
              dispatch(setShowModal(false));
            })
            .catch((err) => {
              console.error(err);
            });
        },
      })
    );
  };

  const handleSend = (notice_id) => {
    pushNotify(notice_id)
      .then((res) => {
        fetchNotifications();
        addDefaultSnack("Уведомление успешно отправлено");
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const renderHtmlText = (text) => {
    if (!text) return null;
    const withBr = text.replace(/\r\n|\r|\n/g, "<br/>");
    return <span dangerouslySetInnerHTML={{ __html: withBr }} />;
  };
  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-end",
          flexWrap: "wrap",
          gap: "20px",
          padding: "60px 0 0 20px",
        }}
      >
        <Box sx={{ minWidth: 200 }}>
          <CustomButton
            btnText="Добавить"
            handleClick={() => handleOpenModal()}
          />
        </Box>
      </Box>
      <Box className={classes.repair}>
        <EmptyOrShow loading={loading}>
          <TableContainer className={classes.table_container}>
            <Table size="small" aria-label="a sticky dense table">
              <TableHeadComp data={titleArray} />
              <TableBody className={classes.table_body}>
                {Array.isArray(qNotifications) && qNotifications.length > 0 ? (
                  qNotifications.map((notification, index) => (
                    <TableRow key={index}>
                      <TableCell align="center">
                        {notification.notice_id}
                      </TableCell>
                      <TableCell align="left">
                      {renderHtmlText(unicodeEscapesToEmoji(notification.head_text)  || "")}
                      </TableCell>
                      <TableCell align="left">
                        <ExpandableText
                          text={unicodeEscapesToEmoji(notification.body_text)  || ""}
                          renderHtml={renderHtmlText}
                        />
                      </TableCell>
                      <TableCell align="center">
                        {notification.current_day ? "Да" : "Нет"}
                      </TableCell>
                      <TableCell align="center">{notification.fio}</TableCell>
                      <TableCell align="center">
                        {notification.date_create}
                      </TableCell>
                      <TableCell align="center">
                        {notification.is_sent ? (
                          <CheckIcon className={`${classes.sendButton}`} />
                        ) : (
                          <IconButton
                            className={`${classes.actionButton} ${classes.sendButton}`}
                            onClick={() => handleSend(notification.notice_id)}
                          >
                            <SendIcon />
                          </IconButton>
                        )}
                      </TableCell>
                      <TableCell align="center">
                        <IconButton
                          className={`${classes.actionButton} ${classes.editButton}`}
                          onClick={() => handleOpenModal(notification)}
                        >
                          <EditIcon />
                        </IconButton>
                      </TableCell>
                      <TableCell align="center">
                        <IconButton
                          className={`${classes.actionButton} ${classes.deleteButton}`}
                          onClick={() => handleDelete(notification.notice_id)}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={8} align="center">
                      Нет данных для отображения
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </EmptyOrShow>
      </Box>
      <NotifyModal
        open={modalOpen}
        onClose={handleCloseModal}
        notification={selectedNotification}
        onSuccess={handleSuccess}
      />
    </Box>
  );
}

export default NotifyUsers;

const titleArray = [
  "ID",
  "Заголовок",
  "Описание",
  "Однодневное уведомление",
  "Кто создал",
  "Дата создания",
  "Отправлено",
  "Редактировать",
  "Удалить",
];
